/**
 * Formata uma string ISO 8601 para exibição no formato dd/MM/yyyy HH:mm (pt-BR).
 * Fonte única de formatação de data/hora do Smart Review (review + curadoria).
 *
 * @param value string ISO; quando ausente/inválida retorna o fallback.
 * @param allowEmpty quando `true`, ausência/invalidez retorna `''` em vez de `'n/d'`.
 */
export function formatDateTimePtBr(value?: string, allowEmpty = false): string {
  if (!value) { return allowEmpty ? '' : 'n/d'; }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) { return allowEmpty ? '' : 'n/d'; }
  return date.toLocaleString('pt-BR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  });
}
